import { gql } from '@apollo/client'

export const MyProjectConfigQuery = gql`
  query MyProjectConfig {
    config {
      notification {
        enabled
        text
      }
    }
  }
`
